export default "* Kurve eller poser til indsamling + poser til affald\n* Bestemmelses-dug eller opslagsbøger\n* Evt. forstørrelsesglas \n";